import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Container,
  Text,
  Flex,
  Badge,
} from "@chakra-ui/react";
import React from "react";
import { withTranslation } from "react-i18next";
import { RiWhatsappFill, RiQuestionAnswerLine } from "react-icons/ri";

const RegisterComp = ({ t }) => {
  return (
    <Box bg="white" w="100%" py={16}>
      <Container maxW={"container.xl"} my={10} id="callCenter">
        <Flex direction="column" align="center" mb={12}>
          <Flex align="center" gap={3} mb={4}>
            <Box
              p={3}
              bg="blue.50"
              borderRadius="full"
              color="blue.500"
            >
              <RiQuestionAnswerLine fontSize="24px" />
            </Box>
            <Text
              textAlign="center"
              fontWeight="700"
              fontSize={{ base: "24px", md: "32px" }}
              color="gray.800"
              fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
            >
              {t("components.freq.title") || "الأسئلة المتكررة"}
            </Text>
          </Flex>
          
        </Flex>

        <Accordion
          defaultIndex={[0]}
          allowMultiple
          bg="white"
          borderRadius="24px"
          p={8}
          boxShadow="0 20px 40px rgba(0,0,0,0.08)"
          border="1px solid"
          borderColor="gray.200"
          maxW="800px"
          mx="auto"
        >
          <AccordionItem border={0} my={3}>
            <h2>
              <AccordionButton
                _active={{ outline: "none" }}
                _focus={{ outline: "none" }}
                _hover={{ 
                  bg: "blue.50",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.1)"
                }}
                p={6}
                borderRadius="16px"
                transition="all 0.3s ease"
                bg="gray.50"
                border="1px solid"
                borderColor="gray.100"
              >
                <AccordionIcon 
                  color="blue.500" 
                  fontSize="24px"
                  mr={4}
                />

                <Box
                  as="span"
                  flex="1"
                  textAlign="right"
                  fontWeight="700"
                  fontSize="22px"
                  color="gray.800"
                  fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                >
                  {t("components.freq.question") || "كيفية التواصل مع الدعم الفني للمنصة؟"}{" "}
                </Box>
              </AccordionButton>
            </h2>
            <AccordionPanel 
              pb={6} 
              dir="rtl" 
              display="flex" 
              gap={4}
              alignItems="center"
              bg="blue.50"
              borderRadius="16px"
              p={6}
              mt={3}
              border="1px solid"
              borderColor="blue.100"
            >
              <Text 
                fontSize="18px" 
                color="gray.700" 
                flex="1"
                fontWeight="500"
                fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
              >
                {t("components.freq.answer") || "تواصل مع الدعم الفني عن طريق"}{" "}
              </Text>
              <a
                href="https://wa.me/+201500235062"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                  color: "white",
                  padding: "12px 24px",
                  borderRadius: "12px",
                  fontWeight: "700",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(37, 211, 102, 0.4)",
                  fontSize: "16px",
                  fontFamily: "'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-3px) scale(1.05)";
                  e.target.style.boxShadow = "0 8px 25px rgba(37, 211, 102, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0) scale(1)";
                  e.target.style.boxShadow = "0 4px 15px rgba(37, 211, 102, 0.4)";
                }}
              >
                <span>WhatsApp</span>
                <RiWhatsappFill fontSize="20px" />
              </a>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Container>
    </Box>
  );
};

export default withTranslation()(RegisterComp);
